import React from 'react';

const BoldLabelInput = ({ field, label }) => {
  return (
    <div className="formulaire-dynamique-main-div form-field-group form-label-bold-container">
      <div className={`formulaire-dynamique-div ${field.texteVertical && 'formulaire-dynamique-label-wrapper'}`}>
        <span className="formulaire-dynamique-span form-label-bold">
          {label}
        </span>
      </div>
    </div>
  );
};

export default BoldLabelInput;

